import React, { useState, forwardRef, useEffect, useRef, useMemo, useCallback } from "react";
import { Button, Form, Row, Col, Collapse } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faFilter } from "@fortawesome/free-solid-svg-icons";
import { registerLocale, setDefaultLocale, CalendarContainer } from "react-datepicker";
import { jwtDecode } from 'jwt-decode';

import {
  GruposService,
  VehiculosService,
  GeocercaService,
  ClienteService,
  ChoferesService,
  ReferenciaService,
} from "../../../../services/apiService";

import { sortBy } from "underscore";

import es from "date-fns/locale/es";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { MultiSelect } from 'primereact/multiselect';
import '../../../../styles/global.css'
import { createRenderCustomHeader } from '../../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../../utils/datePickerUtils';
import '../../../../styles/datepicker.css'
import "primereact/resources/themes/lara-light-blue/theme.css";

import { locale as primeLocale, addLocale } from 'primereact/api'
import { useFiltrosStore } from "../../../../lib/store/filtros.store";
import { useRecorridosStore } from '../../../../lib/store/recorridos.store'
import { Dropdown } from "primereact/dropdown";
import { AccionBitacora, generarObservacion, guardarBitacora } from "../../../../utils/bitacora";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale('es');

// 📌 Registrar la localización en español para DatePicker
registerLocale("es", es);
setDefaultLocale("es"); //

addLocale('es', {
  firstDayOfWeek: 1,
  dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
  monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  today: 'Hoy',
  clear: 'Limpiar',
  option: '',
  selectionMessage: '{0} items seleccionados',
  emptySearchMessage: 'No se encontraron resultados',
  emptyFilterMessage: 'No se encontraron resultados',
  emptyMessage: 'No hay opciones disponibles'
})

export default function Filtros({ onGenerateReport, imprimir, disabled }) {
  // Estados que guardan los datos obtenidos de los endpoint
  //const [vehiculos, setVehiculos] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [geocercas, setGeocercas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [referencias, setReferencias] = useState([]);
  const [choferes, setChoferes] = useState([]);

  // Estados que guardan el dato seleccionado en el formulario de filtros
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [selectedVehicleDrop, setSelectedVehicleDrop] = useState(0);

  const [selectedChoferes, setSelectedChoferes] = useState([]);
  const [btnFiltroActivo, setBtnFiltroActivo] = useState(false);


  // Verificar si mostrar el selector de evento (solo para empresa_id === '153' o '614')
  const empresaId = localStorage.getItem('empresa_id');
  const shouldShowEventoSelector = ['153', '614'].includes(`${empresaId ?? ''}`);

  const [selectedGrupo, setSelectedGrupo] = useState(null);

  const vehiculos = useFiltrosStore((state) => state.vehiculos)
  const setVehiculos = useFiltrosStore((state) => state.setVehiculos)
  const vehiculosFiltrado = useFiltrosStore((state) => state.vehiculosFiltrado)
  const setVehiculosFiltrados = useFiltrosStore((state) => state.setVehiculosFiltrados)
  // Estado para el selector de Abierto/Cerrado (solo visible para empresa_id === '153')
  const eventoSeleccionado = useFiltrosStore((state) => state.eventoSeleccionado)
  const setEventoSeleccionado = useFiltrosStore((state) => state.setEventoSeleccionado)

  // Referencia para el Dropdown de vehículos
  const dropdownVehiculoRef = useRef(null);

  // Estado para controlar la visibilidad del dropdown de vehículos
  const [dropdownVehiculoVisible, setDropdownVehiculoVisible] = useState(false);

  // Estado para abrir u ocultar el filtro
  const [open, setOpen] = useState(true);

  // Establecer valores iniciales para las fechas
  const now = new Date();
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)

  // Inicializar fechas con el día actual
  const [startDate, setStartDate] = useState(startOfDay);
  const [endDate, setEndDate] = useState(endOfDay);
  const [dateRangeError, setDateRangeError] = useState("");

  // Handle functions for DatePicker onChange and custom header
  const handleStartDateChangeWrapper = useCallback((date) => {
    handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
  }, [startDate, endDate]);

  const handleEndDateChangeWrapper = useCallback((date) => {
    handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
  }, [startDate, endDate]);

  // Validación de rango de fechas (máximo 30 días)
  useEffect(() => {
    debugger;
    if (startDate && endDate) {
      const diffInMs = endDate - startDate;
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
      if (diffInDays > 30) {
        setBtnFiltroActivo(false);
        setDateRangeError("El rango de fechas no puede exceder 30 días.");
        // Swal.fire({
        //   icon: 'warning',
        //   title: 'Rango de fechas inválido',
        //   text: 'El rango de fechas no puede exceder 30 días.',
        //   confirmButtonText: 'Aceptar'
        // });
      } else {
        setDateRangeError("");
        if (selectedVehicle != null && selectedVehicle.length > 0) {
          setBtnFiltroActivo(true);
        }
        else {
          setBtnFiltroActivo(false);
        }
      }
    }
  }, [startDate, endDate, selectedVehicle,]);

  const loadGrupos = async () => {
    try {
      const response = await GruposService.getGrupos();
      if (response && response.statusCode === 200) {

        const _grupos = sortBy(response.data, 'nombre')

        const gruposData = _grupos.map((grupo) => ({
          value: grupo.uid_grupo,
          label: `${grupo.nombre}`,
          uid_grupo: grupo.uid_grupo
        }));

        //setSelectedGrupo(gruposData)
        setGrupos(gruposData);
      }
    } catch (error) {
      console.error("Error cargando los grupos:", error);
    }
  };


  // const loadVehiculos = async () => {
  //   try {
  //     const response = await VehiculosService.getVehiculos();
  //     if (response && response.statusCode === 200) {

  //       const _vehiculos = sortBy(response.data, function (i) { return i.alias.trim().toUpperCase() })

  //       const vehiculosData = _vehiculos.map((vehiculo) => ({
  //         value: vehiculo.uid_vehiculo,
  //         id: vehiculo.id_vehiculo,
  //         label: `${vehiculo.no_economico} / ${vehiculo.alias}`,
  //         uid_grupo: vehiculo.uid_grupo,
  //         no_economico: vehiculo.no_economico,
  //         alias: `${vehiculo.alias}`,
  //         tipo_vehiculo: vehiculo.tipo_vehiculo || 'sedan', // default
  //         color_vehiculo: vehiculo.color_vehiculo || '#000000' // default 
  //       }));
  //       setVehiculos(vehiculosData);
  //       setVehiculosFiltrados([])
  //     }
  //   } catch (error) {
  //     console.error("Error cargando vehículos:", error);
  //   }
  // };

  const loadVehiculos = async () => {
    try {
      const response = await VehiculosService.getVehiculos();

      if (response && response.statusCode === 200) {
        const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });

        const vehiculosData = _vehiculos.map(vehiculo => ({
          value: vehiculo.uid_vehiculo ?? "",
          label: `${vehiculo.no_economico ?? ""} / ${vehiculo.alias ?? ""}`,
          uid_grupo: vehiculo.uid_grupo ?? "",
          no_economico: vehiculo.no_economico ?? "",
          alias: `${vehiculo.alias ?? ""}`,
          tipo_vehiculo: vehiculo.tipo_vehiculo ?? "",
          color_vehiculo: vehiculo.color_vehiculo ?? ""
        }));
        setVehiculos(vehiculosData);
        setVehiculosFiltrados([]);
      }
    } catch (error) {
      console.error("Error cargando vehículos:", error);
    }
  };


  const loadGeocercas = async () => {
    try {
      const response = await GeocercaService.getGeocercas();
      if (response && response.statusCode === 200) {
        // console.log(response);
        const _geocercas = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

        setGeocercas(_geocercas);
      }
    } catch (err) {
      console.error("Error cargando geocercas:", err);
    }
    /*  try {
       const response = await GeocercaService.getGeocercas();
       if (response && response.statusCode === 200) {
 
         const _geocercas = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })
 
         const geocercasData = _geocercas.map((geocerca) => ({
           value: geocerca.uid_geocerca,
           label: `${geocerca.nombre}`,
         }))
 
         setGeocercas(geocercasData);
       }
     } catch (err) {
       console.error("Error cargando geocercas:", err);
     } */
  };

  const loadClientes = async () => {
    try {
      const response = await ClienteService.getClientes();
      if (response && response.statusCode === 200) {

        const _clientes = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

        const clientesData = _clientes.map((cliente) => ({
          value: cliente.uid_cliente,
          label: `${cliente.nombre}`,
          nombre: `${cliente.nombre}`,
          latitud: cliente.latitud,
          longitud: cliente.longitud,
          radio: cliente.radio || 0, // Asegurarse de que radio tenga un valor por defecto
        }))
        setClientes(clientesData);
      }
    } catch (err) {
      console.error("Error cargando clientes:", err);
    }
  };

  const loadChoferes = async () => {
    try {
      const response = await ChoferesService.getChoferes();
      if (response && response.statusCode === 200) {

        const _choferes = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

        const choferesData = _choferes.map((chofer) => ({
          value: chofer.uid_chofer,
          label: `${chofer.nombre}`,
        }))

        setChoferes(choferesData);
      }
    } catch (err) {
      console.error("Error cargando choferes:", err);
    }
  };

  const loadReferencias = async () => {
    try {
      const response = await ReferenciaService.getReferencias();
      if (response && response.statusCode === 200) {

        const _referencias = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

        const referenciasData = _referencias.map((referencia) => ({
          value: referencia.uid_referencia,
          label: `${referencia.nombre}`,
          nombre: `${referencia.nombre}`,
          latitud: referencia.latitud,
          longitud: referencia.longitud,
          radio: referencia.radio || 0, // Asegurarse de que radio tenga un valor por defecto
        }))
        setReferencias(referenciasData);

      }
    } catch (err) {
      console.log("Error cargando referencias:", err);
    }
  };

  useEffect(() => {
    loadGrupos()
    loadVehiculos();
    loadGeocercas();
    loadClientes();
    //loadChoferes();
    loadReferencias();
  }, []);

  useEffect(() => {

    setVehiculosFiltrados(selectedGrupo || [])
  }, [selectedGrupo]);

  /*   useEffect(() => {
      if (selectedVehicle != null && selectedVehicle.length > 0) {
        setBtnFiltroActivo(true);
      } else {
        setBtnFiltroActivo(false);
      }
    }, [selectedVehicle]); */

  const handleDropVehicle = (value) => {
    if (value) {
      const dataSelected = [value];
      setSelectedVehicle(dataSelected);
      setSelectedVehicleDrop(value);
    }
    else {
      setSelectedVehicle([]);
      setSelectedVehicleDrop(null);
    }

    // Reabrir el dropdown para enfocar el filtro
    setDropdownVehiculoVisible(true);
  };


  // Al seleccionar los filtros, los pasamos al contenedor padre (index)
  // const handleGenerate = () => {
  //   setOpen(false);

  //   // 🔹 Ajustar fechas a la zona horaria local para que coincidan con la selección del usuario
  //   /*const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
  //   const fecha_inicio = new Date(startDate.getTime() - offset).toISOString(); // Ajustar a UTC
  //   const fecha_fin = new Date(endDate.getTime() - offset).toISOString(); // Ajustar a UTC*/

  //   const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
  //   const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")

  //   onGenerateReport({
  //     fecha_inicio: _fechaInicio,
  //     fecha_fin: _fechaFin,
  //     uids_vehiculos: selectedVehicle && selectedVehicle.length > 0
  //       ? selectedVehicle.map((v) => v)
  //       : [],
  //     uids_geocercas:
  //       selectedGeocercas && selectedGeocercas.length > 0
  //         ? selectedGeocercas.map((g) => g)
  //         : [],
  //     uids_clientes:
  //       selectedClientes && selectedClientes.length > 0
  //         ? selectedClientes.map((c) => c)
  //         : [],
  //     uids_referencias:
  //       selectedReferencias && selectedReferencias.length > 0
  //         ? selectedReferencias.map((r) => r)
  //         : [],
  //     uids_choferes:
  //       selectedChoferes && selectedChoferes.length > 0
  //         ? selectedChoferes.map((c) => c)
  //         : [],
  //     tipo: "Todo",
  //     pagina: 0,
  //     recalculo_geocercas: false,
  //   });
  // };

  const handleGenerate = () => {
    setOpen(false);

    const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
    const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")

    // Obtener información del token
    const decoded = jwtDecode(localStorage.getItem('token'));
    generarBitacoraReporte(AccionBitacora.Generar);
    // Crear el objeto de filtros con el formato correcto
    onGenerateReport({
      fecha_inicio: _fechaInicio,
      fecha_fin: _fechaFin,
      uids_vehiculo: selectedVehicle && selectedVehicle.length > 0  // SINGULAR "vehiculo" (no "vehiculos")
        ? selectedVehicle.map((v) => v)
        : [],
      // Los siguientes campos no son necesarios para la API de ubicación pero conservarlos no afecta
      uids_geocercas: [],
      uids_clientes: [],
      uids_referencias: [],
      uids_choferes: selectedChoferes && selectedChoferes.length > 0
        ? selectedChoferes.map((c) => c)
        : [],
      geocercas: geocercas,
      clientes: clientes,
      referencias: referencias,
      // Campos adicionales requeridos por la API
      empresaUid: decoded.uid_empresa,
      page: 1,                      // EN LUGAR DE "pagina"
      limit: 10000,
      uid_usuario: decoded.uid_usuario,
      perfil: 1,
      count: true,
      // Campos opcionales que puedes mantener
      tipo: "Todo",
      recalculo_geocercas: false,
      order: 1
    });
  };

  useEffect(() => {
    guardarBitacora({ categoria: 'Reporte Recorridos', observacion: 'Recorridos', tipoAccion: AccionBitacora.EntrarReporte });
    window.guardarBitacoraPrint = () => {
      generarBitacoraReporte(AccionBitacora.Imprimir);
    };
    window.guardarBitacoraExport = () => {
      generarBitacoraReporte(AccionBitacora.Exportar);
    };
  }, []);
  const filtrosGenerarRef = useRef();
  const generarBitacoraReporte = (accion) => {
    if (accion === AccionBitacora.Generar) {
      let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
      let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
      let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
      let dataGrupos = (grupos || []).filter(w => (selectedGrupo || []).includes(w.value));
      let dataVehiculos = (vehiculos || []).filter(w => (selectedVehicle || []).includes(w.value));
      let dataAlertas = [];
      filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas };
    }
    guardarBitacora({
      categoria: 'Reporte Recorridos',
      observacion: generarObservacion(
        'Recorridos',
        {
          fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
          hora_inicio: filtrosGenerarRef.current.hora_inicio,
          fecha_fin: filtrosGenerarRef.current.fecha_fin,
          grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
          vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
          tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
        }
      ),
      tipoAccion: accion
    });
  }
  // 📌 Método para manejar cualquier Select
  const handleSelectChange = (selected, options, setSelected) => {
    const allSelected = selected.some((option) => option.value === "all");

    const todasLasOpciones = options.flatMap((grupo) => grupo.options || grupo);

    if (allSelected) {
      if (selected.length === todasLasOpciones.length + 1) {
        // 🔹 Se suma 1 por la opción "Seleccionar todos"
        setSelected([]); // 🔹 Deseleccionar todo correctamente
      } else {
        setSelected(todasLasOpciones); // 🔹 Seleccionar todas las opciones ignorando los agrupadores
      }
    } else {
      setSelected(selected);
    }
  };


  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "34px",
      overflow: "hidden",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "34px",
      overflow: "hidden",
    }),
  };

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="position-relative">
      <Form.Control
        ref={ref}
        onClick={onClick}
        value={value}
        className=""
        onChange={() => { }}
      />

    </div>
  ));

  const renderIniHeader = useMemo(
    () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
    [startDate, handleStartDateChangeWrapper]
  );
  const renderEndHeader = useMemo(
    () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
    [endDate, handleEndDateChangeWrapper]
  );

  return (
    <div>

      {/* <Collapse in={open}> */}
      <div id="filter-collapse">
        <Row className="mb-3">
          {dateRangeError && (
            <Col xs={12}>
              <div className="alert alert-warning py-2 my-2">
                {dateRangeError}
              </div>
            </Col>
          )}
          {/* Fecha Incicio */}
          <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label >Desde</Form.Label>
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChangeWrapper}
                customInput={<ExampleCustomInput />}
                dateFormat="dd/MM/yyyy HH:mm:ss" // Formato de 12 horas con AM/PM

                locale="es"
                maxDate={new Date()}
                fixedHeight
                renderCustomHeader={renderIniHeader}
                popperClassName="custom-datepicker-popper"
              />
              {/* <DatePicker
                selected={startDate}
                //maxDate={endOfDay}
                onChange={date => {
                  const mismoDia = startDate.getDate() === date.getDate() && startDate.getMonth() === date.getMonth() && startDate.getFullYear() === date.getFullYear();
                  const nuevaFecha = mismoDia ? date : new Date(date.getFullYear(), date.getMonth(), date.getDate(), startDate.getHours(), startDate.getMinutes(), startDate.getSeconds());
                  setStartDate(nuevaFecha);
                  // Auto-ajustar endDate si la nueva fecha de inicio es posterior a endDate
                  if (nuevaFecha > endDate) {
                    setEndDate(nuevaFecha);
                  }
                }}
                customInput={<ExampleCustomInput />}
                timeIntervals={5}
                dateFormat="dd/MM/yyyy HH:mm"
                showTimeInput // Habilita la entrada de tiempo
                customTimeInput={<CustomTimeInput />}

                fixedHeight
                locale="es" // 📌 Localización en español
                timeCaption="Hora" //
                maxDate={new Date()}
                popperClassName="custom-datepicker-popper"
              /> */}
            </Form.Group>
          </Col>

          {/* Fecha Fin */}
          <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label >Hasta</Form.Label>
              <DatePicker
                selected={endDate}
                minDate={startDate}
                minTime={
                  endDate.getDate() === startDate.getDate()
                    ? startDate
                    : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                }
                maxTime={
                  endDate.getDate() === new Date().getDate() &&
                    endDate.getMonth() === new Date().getMonth() &&
                    endDate.getFullYear() === new Date().getFullYear()
                    ? new Date() // hasta la hora actual si es hoy
                    : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59) // hasta fin del día
                }
                onChange={handleEndDateChangeWrapper}
                customInput={<ExampleCustomInput />}
                timeIntervals={5}
                dateFormat="dd/MM/yyyy HH:mm:ss"
                renderCustomHeader={renderEndHeader}
                fixedHeight
                locale="es" // 📌 Localización en español
                timeCaption="Hora" //
                maxDate={new Date()}
              />
            </Form.Group>
          </Col>
          <Col md={3} xs={4}>
            <Form.Label >Grupo</Form.Label>
            <MultiSelect
              className="multiselect-ul w-full md:w-20rem"
              value={selectedGrupo}
              onChange={(e) => {
                setSelectedGrupo(e.value);
                handleDropVehicle([]);
              }}
              options={grupos}
              optionLabel="label"
              filter
              placeholder="Seleccione un grupo"
              maxSelectedLabels={2}
              selectedItemsLabel={`${(selectedGrupo || []).length} grupos seleccionados`}
            />
          </Col>
          {/* Vehiculos */}
          <Col md={3} xs={4} >
            <Form.Label >Vehículos</Form.Label>
            <Dropdown
              ref={dropdownVehiculoRef}
              className={`w-full md:w-14rem ${selectedVehicleDrop ? "selected-value" : "placeholder-value"}`}
              value={selectedVehicleDrop}
              options={vehiculosFiltrado}
              onChange={(selected) => handleDropVehicle(selected.value)}
              optionLabel="label"
              placeholder="Selecciona un vehículo"
              checkmark={true}
              highlightOnSelect={false}
              styles={customStyles}
              filter
              appendTo={document.body}
              onShow={() => {
                setDropdownVehiculoVisible(true);
                setTimeout(() => {
                  const overlay = dropdownVehiculoRef.current?.getOverlay();
                  if (overlay) {
                    const filterInput = overlay.querySelector('.p-dropdown-filter');
                    if (filterInput) filterInput.focus();
                  }
                }, 100);
              }}
              onHide={() => setDropdownVehiculoVisible(false)}
              onClick={() => setDropdownVehiculoVisible(true)}
            >

            </Dropdown>
          </Col>
          {/**
           * <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Vehículos</Form.Label>
              <Select
                closeMenuOnSelect={true}
                options={[...vehiculos]}
                classNamePrefix="react-select"
                value={selectedVehicle}
                onChange={(selected) => setSelectedVehicle(selected)}
                styles={customStyles}
              />
            </Form.Group>
          </Col>
           */}
        </Row>
        <Row className="mt-2">
          {/* Geocercas */}
          {/* <Col md={3} xs={4} className="d-flex flex-column">
            <label>Geocercas</label>
            <MultiSelect
              className="multiselect-ul"
              value={selectedGeocercas}
              onChange={(e) => setSelectedGeocercas(e.value)}
              options={geocercas}
              optionLabel="label"
              filter
              placeholder="Seleccione una geocerca"
              maxSelectedLabels={2}
            />
          </Col> */}
          {/**
           * <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Geocercas</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={[
                  ...(selectedGeocercas.length !== geocercas.length
                    ? [{ value: "all", label: "Seleccionar todas" }]
                    : [{ value: "all", label: "Deseleccionar todas" }]),
                  ...geocercas,
                ]}
                classNamePrefix="react-select"
                value={selectedGeocercas}
                onChange={(selected) =>
                  handleSelectChange(
                    selected,
                    geocercas,
                    setSelectedGeocercas
                  )
                }
                isMulti
                styles={customStyles}
              />
            </Form.Group>
          </Col>
           */}
          {/* Clientes */}
          {/* <Col md={3} xs={4} className="d-flex flex-column">
            <label>Clientes</label>
            <MultiSelect
              className="multiselect-ul"
              value={selectedClientes}
              onChange={(e) => setSelectedClientes(e.value)}
              options={clientes}
              optionLabel="label"
              filter
              placeholder="Seleccione un cliente"
              maxSelectedLabels={2}
            />
          </Col> */}
          {/**
           * <Col md={3} xs={4}>
            <Form.Group>
              <Form.Label>Clientes</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={[
                  ...(selectedClientes.length !== clientes.length
                    ? [{ value: "all", label: "Seleccionar todos" }]
                    : [{ value: "all", label: "Deseleccionar todos" }]),
                  ...clientes,
                ]}
                classNamePrefix="react-select"
                value={selectedClientes}
                onChange={(selected) =>
                  handleSelectChange(selected, clientes, setSelectedClientes)
                }
                isMulti
                styles={customStyles}
              />
            </Form.Group>
          </Col>
           */}
          {/* Referencias */}
          {/* <Col md={2} xs={4} className="d-flex flex-column">
            <label>Referencias</label>
            <MultiSelect
              className="multiselect-ul"
              value={selectedReferencias}
              onChange={(e) => setSelectedReferencias(e.value)}
              options={referencias}
              optionLabel="label"
              filter
              placeholder="Seleccione una referencia"
              maxSelectedLabels={2}
            />
          </Col> */}
          {/**
           * <Col md={2} xs={4}>
            <Form.Group>
              <Form.Label>Referencias</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={[
                  ...(selectedReferencias.length !== referencias.length
                    ? [{ value: "all", label: "Seleccionar todas" }]
                    : [{ value: "all", label: "Deseleccionar todas" }]),
                  ...referencias,
                ]}
                classNamePrefix="react-select"
                value={selectedReferencias}
                onChange={(selected) =>
                  handleSelectChange(
                    selected,
                    referencias,
                    setSelectedReferencias
                  )
                }
                isMulti
                styles={customStyles}
              />
            </Form.Group>
          </Col>
           */}
          {/* Choferes */}
          {/* <Col md={2} xs={4} className="d-flex flex-column">
            <label>Choferes</label>
            <MultiSelect
              className="multiselect-ul"
              value={selectedChoferes}
              onChange={(e) => setSelectedChoferes(e.value)}
              options={choferes}
              optionLabel="label"
              filter
              placeholder="Seleccione un chofer"
              maxSelectedLabels={2}
            />
          </Col> */}
          {/**
           * <Col md={2} xs={4}>
            <Form.Group>
              <Form.Label>Choferes</Form.Label>
              <Select
                closeMenuOnSelect={false}
                options={[
                  ...(selectedChoferes.length !== choferes.length
                    ? [{ value: "all", label: "Seleccionar todos" }]
                    : [{ value: "all", label: "Deseleccionar todos" }]),
                  ...choferes,
                ]}
                classNamePrefix="react-select"
                value={selectedChoferes}
                onChange={(selected) =>
                  handleSelectChange(selected, choferes, setSelectedChoferes)
                }
                isMulti
                styles={customStyles}
              />
            </Form.Group>
          </Col>
           */}

          {/* Evento (Abierto/Cerrado) - Solo para empresa_id === '153' */}
          {shouldShowEventoSelector && (
            <Col md={3} xs={4}>
              <Form.Label>Evento</Form.Label>
              <MultiSelect
                className="multiselect-ul w-full md:w-20rem"
                value={eventoSeleccionado}
                onChange={(selected) => {
                  setEventoSeleccionado(selected.value);
                }}
                options={[
                  { value: 'abierto', label: 'Abierto' },
                  { value: 'cerrado', label: 'Cerrado' }
                ]}
                optionLabel="label"
                placeholder="Seleccione un evento"
                maxSelectedLabels={2}
                selectedItemsLabel={`${(eventoSeleccionado || []).length} eventos seleccionados`}
              />
            </Col>
          )}

          {/* Boton Generar */}
          <Col md={2} xs={4} className="ms-auto">
            <div className="d-flex justify-content-center mt-4">
              <Button
                variant="primary"
                onClick={handleGenerate}
                className="w-100"
                disabled={!btnFiltroActivo || disabled}
              >
                Generar
              </Button>
            </div>
          </Col>
          <Col md={2} xs={4}>
            <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
            </div>
          </Col>
        </Row>
      </div>
      {/* </Collapse> */}
    </div>
  );
}
